import React from 'react'
import { Box } from '@mui/material'

export const HomeRailsScrollableContainer = ({ children, scrollContainerRef, onScroll, dataTest }) => {
  return (
    <Box
      ref={scrollContainerRef}
      onScroll={onScroll}
      data-test={dataTest}
      sx={{
        display: 'flex',
        overflowX: 'auto',
        overflowY: 'hidden',
        scrollBehavior: 'smooth',
        flexWrap: 'nowrap',
        gap: 2,
        pb: 2,
        scrollbarWidth: 'none', // Firefox
        '&::-webkit-scrollbar': {
          display: 'none' // Chrome, Safari
        },
        '&::-webkit-scrollbar-track': {
          display: 'none'
        },
        '&::-webkit-scrollbar-thumb': {
          display: 'none'
        }
      }}
    >
      {children}
    </Box>
  )
}
